
// Main product script
document.addEventListener('DOMContentLoaded', () => {

  const productEl = document.querySelector('#product');
  if (!productEl) return;

  const sectionId = productEl.dataset.sectionId;
  const optionSelectors = productEl.querySelector('.optionValueSelectors');

  const priceEl = document.querySelector(`#ProductPrice-${sectionId}`);
  const variantInput = document.querySelector(`#VariantIdInput-${sectionId}`);
  const form = document.querySelector(`#AddToCartForm-${sectionId}`);
  const addToCartBtn = form?.querySelector('.add-to-cart-custom');

  if (!variantInput || !form || !addToCartBtn || !priceEl) return;

  /* =====================================================
      GLOBAL STATE
  ===================================================== */
  let baseVariantPrice = 0; // Variant price only
  let selectedAccessories = [];
  let accessoryTotalCents = 0;

  /* =====================================================
      FORMAT MONEY (simple version)
  ===================================================== */
  function formatMoney(value) {
    return value.toFixed(2);
  }

  /* =====================================================
      UPDATE TOTAL PRICE (MAIN + ACCESSORIES)
  ===================================================== */
  function updateTotalPriceDisplay() {

    const finalPrice =
      baseVariantPrice + (accessoryTotalCents / 100);

    // Update main product price block
    priceEl.innerHTML = `$${formatMoney(finalPrice)}`

    // Update Add To Cart button price
    addToCartBtn.innerHTML = `
      Add to Cart
      <span class="product__price price-inside-btn">
        ($${formatMoney(finalPrice)})
      </span>
    `;
  }

  /* =====================================================
      TOGGLE ADD TO CART (INVENTORY)
  ===================================================== */
  function toggleAddToCartButton(inventory) {
    const qty = parseInt(inventory, 10);

    if (isNaN(qty) || qty <= 0) {
      addToCartBtn.disabled = true;
      addToCartBtn.classList.add('is-disabled');
      addToCartBtn.innerHTML = 'Out of Stock';
    } else {
      addToCartBtn.disabled = false;
      addToCartBtn.classList.remove('is-disabled');
      updateTotalPriceDisplay();
    }
  }

  /* =====================================================
      INITIAL BASE PRICE SET
  ===================================================== */
  baseVariantPrice = parseFloat(
    priceEl.textContent.replace(/[^0-9.]/g, '')
  ) || 0;

  updateTotalPriceDisplay();

  /* =====================================================
      UPDATE SELECTED OPTION LABEL
  ===================================================== */
  function updateSelectedOptionDisplay(input) {
    const optionName = input.dataset.optionName;
    const value = input.value;

    const displayEl = document.querySelector(
      `#SelectedOption-${optionName.toLowerCase().replace(/\s+/g, '-')}`
    );

    if (displayEl) {
      displayEl.innerHTML = `${optionName} — 
        <span class="variant__label-info">${value}</span>`;
    }
  }



/* =====================================================
   VARIANT CHANGE HANDLER (RADIO + DROPDOWN)
===================================================== */
if (optionSelectors) {

  optionSelectors.addEventListener('change', async (event) => {

    const input = event.target;

    // run only for variant selectors
    if (
      !input.matches('input[type="radio"]') &&
      !input.matches('select')
    ) return;

    /* -----------------------------------------
       UPDATE LABEL DISPLAY
    ----------------------------------------- */
    if (input.matches('input[type="radio"]')) {
      updateSelectedOptionDisplay(input);
    }

    if (input.matches('select')) {
      const optionName = input.dataset.optionName;
      const value = input.options[input.selectedIndex].value;

      const displayEl = document.querySelector(
        `#SelectedOption-${optionName.toLowerCase().replace(/\s+/g, '-')}`
      );

      if (displayEl) {
        displayEl.innerHTML = `${optionName} —
          <span class="variant__label-info">${value}</span>`;
      }
    }

    /* -----------------------------------------
       COLLECT ALL SELECTED OPTION VALUE IDS
    ----------------------------------------- */

    const selectedOptionValues = [];

    // radio selections
    optionSelectors
      .querySelectorAll('input[type="radio"]:checked')
      .forEach((el) => {
        if (el.dataset.optionValueId) {
          selectedOptionValues.push(el.dataset.optionValueId);
        }
      });

    // dropdown selections
    optionSelectors
      .querySelectorAll('select')
      .forEach((select) => {
        const opt = select.options[select.selectedIndex];

        if (opt?.dataset.optionValueId) {
          selectedOptionValues.push(opt.dataset.optionValueId);
        }
      });

    const params = selectedOptionValues.length
      ? `&option_values=${selectedOptionValues.join(',')}`
      : '';

    /* -----------------------------------------
       FETCH UPDATED VARIANT SECTION
    ----------------------------------------- */

    const res = await fetch(
      `${productEl.dataset.productUrl}?section_id=${sectionId}${params}`
    );

    const html = new DOMParser().parseFromString(
      await res.text(),
      'text/html'
    );

    const newPriceHTML = html.querySelector(
      `#ProductPrice-${sectionId}`
    )?.innerHTML;

    const newVariantInput = html.querySelector(
      `#VariantIdInput-${sectionId}`
    );

    /* -----------------------------------------
       UPDATE PRICE
    ----------------------------------------- */

    if (newPriceHTML) {

      priceEl.innerHTML = newPriceHTML;

      baseVariantPrice = parseFloat(
        newPriceHTML.replace(/[^0-9.]/g, '')
      ) || 0;
    }

    /* -----------------------------------------
       UPDATE VARIANT ID
    ----------------------------------------- */

    if (newVariantInput) {

      variantInput.value = newVariantInput.value;

      variantInput.dataset.inventory =
        newVariantInput.dataset.inventory;

      const url = new URL(window.location);

      url.searchParams.set(
        'variant',
        newVariantInput.value
      );

      window.history.replaceState({}, '', url);

      toggleAddToCartButton(
        newVariantInput.dataset.inventory
      );
    }

    updateTotalPriceDisplay();

  });

}

  /* =====================================================
      ACCESSORY SELECTION
  ===================================================== */
  // document.addEventListener('change', function (e) {

  //   if (!e.target.classList.contains('accessory-checkbox')) return;

  //   const checkedAccessories =
  //     document.querySelectorAll('.accessory-checkbox:checked');

  //   selectedAccessories = [];
  //   accessoryTotalCents = 0;

  //   checkedAccessories.forEach((checkbox) => {

  //     selectedAccessories.push({
  //       id: checkbox.dataset.id,
  //       quantity: 1
  //     });

  //     accessoryTotalCents += parseInt(
  //       checkbox.dataset.price,
  //       10
  //     );
  //   });

  //   updateTotalPriceDisplay();
  // });

  document.addEventListener('change', function (e) {
  if (!e.target.classList.contains('accessory-checkbox')) return;

  const checkedAccessories = document.querySelectorAll('.accessory-checkbox:checked');

  selectedAccessories = [];
  accessoryTotalCents = 0;

  checkedAccessories.forEach((checkbox) => {
    selectedAccessories.push({
      id: checkbox.dataset.id,
      quantity: 1
    });

    accessoryTotalCents += parseInt(checkbox.dataset.price, 10);
  });

  updateTotalPriceDisplay();
});

  /* =====================================================
      FABRIC CARD VARIANT REDIRECT
  ===================================================== */
  const fabricCards = document.querySelectorAll('.fabric-card');

  fabricCards.forEach((card) => {

    card.addEventListener('click', function () {

      const input = this.querySelector('input[type="radio"]');
      if (!input || input.disabled) return;

      fabricCards.forEach((c) =>
        c.classList.remove('active')
      );

      this.classList.add('active');
      input.checked = true;

      const variantId = input.dataset.variantId;

      if (variantId) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variantId);
        window.location.href = url.toString();
      }
    });

  });


console.log("Variant Input:", variantInput.value);
console.log("URL Variant:", new URLSearchParams(window.location.search).get('variant'));
console.log("All Variants:", window.product.variants);

  /* =====================================================
      ADD TO CART (MAIN + ACCESSORIES)
  ===================================================== */

  form.addEventListener('submit', async (e) => {

    e.preventDefault();
    if (addToCartBtn.disabled) return;

    const items = [
      {
        id: variantInput.value,
        quantity: 1,
      },
      ...selectedAccessories
    ];

    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items }),
    });

    if (res.ok) {
      window.location.href = '/cart';
    } else {
      alert('Error adding to cart');
    }

  });

});



// =====================Product thumbnail script =====================
document.addEventListener('DOMContentLoaded', function () {

  const mainProductImage = document.getElementById('main-product-image');
  const swatchInputs = document.querySelectorAll('.variant-input-wrap input');

  if (!mainProductImage) return;

  swatchInputs.forEach(input => {

    input.addEventListener('change', function () {

      if (!this.checked) return;

      const newImage = this.dataset.variantThumb;

      if (newImage) {
        mainProductImage.style.opacity = '0';

        setTimeout(() => {
          mainProductImage.src = newImage;
          mainProductImage.style.opacity = '1';
        }, 100);
      }

    });

  });

});
